import React, { useEffect, useState } from "react";


export default function DwgPdfViewer()
{
    const [pdfUrl, setPdfUrl] =
            useState(null);


    useEffect(() =>
    {
        let objectUrl =
                null;

        let cancelled =
                false;


        async function loadPdf()
        {
            try
            {
                const response =
                        await fetch(
                            "/resolutionsoftwareplatform/gettestdwgpdf",
                            {
                                method: "GET",
                                cache: "no-store"
                            });


                if(!response.ok)
                {
                    console.error(
                        "Unable to load DWG PDF : " +
                        response.status);

                    return;
                }


                const blob =
                        await response.blob();


                if(cancelled)
                {
                    return;
                }


                objectUrl =
                        URL.createObjectURL(
                                blob);


                setPdfUrl(
                        objectUrl);
            }
            catch(error)
            {
                console.error(
                        "Unable to load DWG PDF",
                        error);
            }
        }


        loadPdf();


        return () =>
        {
            cancelled =
                    true;


            if(objectUrl != null)
            {
                URL.revokeObjectURL(
                        objectUrl);
            }
        };

    }, []);


    if(pdfUrl == null)
    {
        return (
            <div
                style={{
                    width: "100%",
                    height: "100%",

                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",

                    background: "#ffffff",

                    fontSize: "13px",
                    color: "#777777"
                }}
            >
                Loading drawing...
            </div>
        );
    }


    return (
        <iframe
            title="DWG PDF Viewer"

            src={pdfUrl}

            style={{
                width: "100%",
                height: "100%",

                border: "none",

                display: "block",

                background: "#ffffff"
            }}
        />
    );
}